import script from "./TopicVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicVideo.vue?vue&type=script&setup=true&lang=js"

import "./TopicVideo.vue?vue&type=style&index=0&id=5e092522&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e092522"]])

export default __exports__